import React, { ReactNode } from 'react';
import type { ThesisPillar } from '../types';

export interface PillarCardProps {
  pillar: ThesisPillar;
  index: number;
  animation: ReactNode;
  isVisible?: boolean;
  animationDelay?: number;
}

export function PillarCard({ 
  pillar, 
  index, 
  animation, 
  isVisible = true,
  animationDelay = 0 
}: PillarCardProps) {
  return (
    <div
      className={`opacity-0 ${isVisible ? 'animate-fade-up' : ''}`}
      style={{ animationDelay: `${animationDelay}s` }}
    >
      {/* Animation area */}
      <div className="relative w-full aspect-square max-h-[200px] md:max-h-[240px] max-w-[400px] mx-auto md:max-w-none flex items-center justify-center overflow-hidden">
        {animation}
        
        {/* Edge fades */}
        <div 
          className="absolute inset-y-0 left-0 w-8 pointer-events-none z-10"
          style={{
            background: 'linear-gradient(to right, hsl(var(--background)) 0%, transparent 100%)',
          }}
        />
        <div 
          className="absolute inset-y-0 right-0 w-8 pointer-events-none z-10"
          style={{
            background: 'linear-gradient(to left, hsl(var(--background)) 0%, transparent 100%)',
          }}
        />
      </div>

      {/* Number */}
      <div className="text-label font-mono mb-4 text-foreground-secondary">
        0{index + 1}
      </div>

      {/* Title */}
      <h3 className="font-display text-heading-lg text-foreground mb-4">
        {pillar.title}
      </h3>

      {/* Description */}
      <p className="font-body text-body-sm text-foreground-tertiary leading-relaxed text-pretty">
        {pillar.description}
      </p>
    </div>
  );
}

export default PillarCard;
